import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { FileUploaderWithTooltipOwnProps } from "./FileUploaderWithTooltip.types";
import { FileUploaderWithTooltip } from "./FileUploaderWithTooltip.layout";

export default compose<React.FC<FileUploaderWithTooltipOwnProps>>(
    withTranslation('onboarding'),
)(FileUploaderWithTooltip);
